import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getJwtToken } from 'utils/jwt';
import Spin from '../components/atoms/Spin/Spin';
import { getUserInfo, loadInitialUserData, setLoading } from '../store/slices/userInfoSlice';
import Routes from './Routes';

const MainRoute = () => {
    const { loading, fullName } = useSelector(getUserInfo);
    const dispatch = useDispatch();
    const token = getJwtToken();
    let { permissions: userPermissions } = useSelector(getUserInfo);
    const { roles, branch } = useSelector(getUserInfo);
    if (userPermissions.length === 0) {
        const permString = localStorage.getItem('permissions');
        if (permString) {
            const permList = JSON.parse(permString);
            if (roles.includes(permList[0])) {
                userPermissions = permList;
            }
        }
    }

    useEffect(() => {
        if (!fullName && token) {
            dispatch(loadInitialUserData());
        } else {
            dispatch(setLoading(false));
        }
    }, [dispatch, fullName, token]);

    return <>{loading ? <Spin size={70} /> : <Routes userPermissions={userPermissions} relogEnabled={branch?.relog_enabled || false} />}</>;
};

export default MainRoute;
